import HTTP from '../../services/HttpService'
import moment from 'moment/moment'
import {PLAN_TYPES} from '../../consts'

/*
  Map customer data from API to customer model.
  That will be used to pre-fill customer data in the onBoarding flow
 */
export function mapCustomerModelToPrefillData ({customerData}) {
  let preFilledData = {
    email: customerData.email,
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    phoneNumber: customerData.phoneNumber,
    pro: customerData.pro,
    ssn: customerData.ssn,
    birthDate: customerData.birthDate,
    birthDateNotFormatted: customerData.birthDate ? moment(customerData.birthDate).format('MM/DD/YYYY') : '',
    hasSoleProprietor: customerData.hasSoleProprietor
  }

  if ('customerAddressData' in customerData && Object.keys(customerData.customerAddressData).length) {
    const addressData = {
      city: customerData.customerAddressData.city,
      line1: customerData.customerAddressData.line1,
      line2: customerData.customerAddressData.line2,
      postalCode: customerData.customerAddressData.postalCode,
      state: customerData.customerAddressData.state
    }

    preFilledData = {...preFilledData, ...addressData}
  }

  if ('customerBusinessData' in customerData && Object.keys(customerData.customerBusinessData).length) {
    const businessData = {
      // Business Data
      businessName: customerData.customerBusinessData.businessName,
      ein: customerData.customerBusinessData.ein,
      businessRegisteredState: customerData.customerBusinessData.incorporationState, // businessState
      incomeType: {id: '', title: '', enum: customerData.customerBusinessData.mainIncomeSource}, // incomeType
      segment: customerData.customerBusinessData.segment || '',
      businessOwners: customerData.customerBusinessData.businessUbos ? customerData.customerBusinessData.businessUbos.uboResponseList : [],
      businessId: customerData.customerBusinessData.externalId || null,
      ownershipPercent: customerData.customerBusinessData.ownershipPercent >= 0 ? customerData.customerBusinessData.ownershipPercent : 50
    }

    if (customerData && customerData.customerBusinessData && customerData.customerBusinessData.naicsIndustry) {
      businessData.sub_industry = customerData.customerBusinessData.naicsIndustry
    }

    preFilledData = {...preFilledData, ...businessData}
  }

  if ('businessAddressData' in customerData && Object.keys(customerData.businessAddressData).length) {
    const businessData = {
      businessLine1: customerData.businessAddressData.line1,
      businessLine2: customerData.businessAddressData.line2,
      businessCity: customerData.businessAddressData.city,
      businessPostalCode: customerData.businessAddressData.postalCode,
      businessAddressState: customerData.businessAddressData.state,
      isPersonalAndBusinessAddressSame: customerData.businessAddressData.sameAsPrimary
    }
    preFilledData = {...preFilledData, ...businessData}
  }

  return preFilledData
}

export function getCustomerModel () {
  return {
    customerId: '',
    accessToken: '',
    stateToken: '',
    phoneNumber: '',
    sourcePlatform: '',
    firstName: '',
    lastName: '',
    address: '',
    email: '',
    birthDateNotFormatted: '',
    adSource: '',
    startOnboarding: '',
    customerKey: '',
    leadExternalId: '',
    birthDate: null,
    line1: '',
    line2: '',
    city: '',
    password: '',
    state: '',
    postalCode: '',
    businessAddressState: '',
    businessPostalCode: '',
    businessCity: '',
    businessLine2: '',
    businessLine1: '',
    ssn: '',
    ein: '',
    segment: '',
    sub_industry: '',
    sub_industry_title: '',
    businessName: '',
    businessRegisteredState: '',
    businessState: '',
    referralCode: '',
    sessionId: '',
    profile: 'SMART',
    isAccountTypeFlow: true,
    isPlanActivelySelected: false,
    incomeType: {id: '', title: '', enum: ''},
    incomeSubType: '',
    incomeTypeFlow: true,
    sortedIncomeTypes: null,
    businessOwners: [],
    // businessOwners: [{'externalId': 'b123236f-eaaf-47d4-a7af-3474e7c3797e', 'email': 'ajwfajwkhfbaw@gmail.com', 'phoneNumber': '+12123345345', 'firstName': 'Awa', 'lastName': 'Awf', 'ssn': '224234545', 'birthDate': '1993-08-08T00:00:00.000+00:00', 'customerAddressData': {'city': 'Whajf', 'state': 'AR', 'line1': 'akwgf', 'line2': '234', 'postalCode': '23234', 'sameAsPrimary': true}, 'role': 'PARTNER_FULL_ACCESS', 'allowEditing': true}, {'externalId': 'b123236f-eaaf-47d4-a7af-3474e7c3797e', 'email': 'ajwfajwkhfbaw@gmail.com', 'phoneNumber': '+12123345345', 'firstName': 'Awa', 'lastName': 'Awf', 'ssn': '224234545', 'birthDate': '1993-08-08T00:00:00.000+00:00', 'customerAddressData': {'city': 'Whajf', 'state': 'AR', 'line1': 'akwgf', 'line2': '234', 'postalCode': '23234', 'sameAsPrimary': true}, 'role': 'PARTNER_FULL_ACCESS', 'allowEditing': true}, {'externalId': 'b123236f-eaaf-47d4-a7af-3474e7c3797e', 'email': 'ajwfajwkhfbaw@gmail.com', 'phoneNumber': '+12123345345', 'firstName': 'Awa', 'lastName': 'Awf', 'ssn': '224234545', 'birthDate': '1993-08-08T00:00:00.000+00:00', 'customerAddressData': {'city': 'Whajf', 'state': 'AR', 'line1': 'akwgf', 'line2': '234', 'postalCode': '23234', 'sameAsPrimary': true}, 'role': 'PARTNER_FULL_ACCESS', 'allowEditing': true}],
    promoData: null,
    availablePromoCodes: {
      [PLAN_TYPES.PRO]: '',
      [PLAN_TYPES.PREMIUM]: '',
      [PLAN_TYPES.SMART]: ''
    },
    institutionData: {
      id: '',
      bankType: ''
    },
    ownershipPercent: 50
  }
}

// Real mock data after manually onBoarding
export function getCustomerMockModel () {
  return {
    'customerId': 'beec35ef-a7ab-4383-9287-9aa89e14ecf5',
    'accessToken': 'eyJraWQiOiIxbXNDVnRaTW85bExhYXpVbjBfYmxiUjFHck9hLXhUQmtCdWk2TGI4Z18wIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULkk2SVhoTEhIaW1vQUVVRUVOal9Oa0VMQ2VkYm9waVUwUnRxX19oU2lqVUkiLCJpc3MiOiJodHRwczovL2Rldi0zNjE5OTAub2t0YXByZXZpZXcuY29tL29hdXRoMi9kZWZhdWx0IiwiYXVkIjoiYXBpOi8vZGVmYXVsdCIsImlhdCI6MTY2ODY3NTg3MiwiZXhwIjoxNjY4Njc2NzcyLCJjaWQiOiIwb2FoM2Y5Y2VyTk5ndTNodjBoNyIsInVpZCI6IjAwdTFmOG14NGQ1cjFJRXpjMGg4Iiwic2NwIjpbImVtYWlsIiwib3BlbmlkIl0sImF1dGhfdGltZSI6MTY2ODY3NTg3Miwic3ViIjoib3VvYWRAZ21haWwuY28iLCJFeHRlcm5hbElkIjoiYmVlYzM1ZWYtYTdhYi00MzgzLTkyODctOWFhODllMTRlY2Y1IiwiZ3JvdXBzIjpbIkV2ZXJ5b25lIiwiT25ib2FyZGluZyJdfQ.vU3wOZYmzjCW2GZkble0oEFSfV1wKHXSTFutv4Xh4DzSSU4u5IgO9oCREb6ytcZC29sTTzt-aPHTQ-26DuXZ--kV0br50bOcLqlByLAjSfLmSHAuG2CpGRgAopitgzw3N2wKYiv86VvcQj6N1mgeolcGH22h92eyG5V9pC_0NfMVZgazY9-IORQuNlhD2ygcZT4Ly4EZhIea_S6cP-uAWGvItEyXHueYdTZPROzMu5LoV_o20NWyIRc0LNTlch4BYSwY8dSK0UAXJWztN7WACh_Wl3LeEMVnZwCKobRqsQgySIS3-Z9IHKFbGKZ8EAB8zws_Hu5wzEKlUfohGIk4vQ',
    'stateToken': '',
    'phoneNumber': '2124232342',
    'sourcePlatform': null,
    'firstName': 'Awd',
    'lastName': 'Awdaw',
    'address': '',
    'email': 'ouoad@gmail.co',
    'birthDateNotFormatted': '08/08/1994',
    'adSource': '{"CID":"GA1.1.777304951.1654782420","afUserId":"628f4901-33bb-4ba3-8260-974b8befd845-p"}',
    'startOnboarding': 1668675854459,
    'leadExternalId': '',
    'birthDate': '1994-08-08T00:00:00.000Z',
    'line1': 'Yona tzvi',
    'line2': '',
    'city': 'Rishon le zion',
    'password': 'password',
    'state': 'AZ',
    'postalCode': '75548',
    'businessAddressState': 'AZ',
    'businessPostalCode': '75548',
    'businessCity': 'Rishon le zion',
    'businessLine2': '',
    'businessLine1': 'Yona tzvi',
    'ssn': '435345345',
    'ein': '434534535',
    'segment': 'Business Consultant',
    'businessName': 'awdaw',
    'businessRegisteredState': 'AR',
    'sessionId': '',
    'pro': true,
    'isAccountTypeFlow': true,
    'isPlanActivelySelected': false,
    'incomeType': 'MMLLC',
    'incomeSubType': '',
    'incomeTypeFlow': true,
    'sortedIncomeTypes': null,
    'businessOwners': [
      {
        'externalId': '2fb76f05-3da7-4fb9-a5b5-fac21dcdcc9c',
        'email': 'jnaknawf@lili.com',
        'phoneNumber': '+12125879345',
        'firstName': 'Awda',
        'lastName': 'Awdwa',
        'ssn': '234242342',
        'birthDate': '1994-08-07T21:00:00.000+00:00',
        'customerAddressData': {
          'city': 'Rishon Le Zion',
          'state': 'AZ',
          'line1': 'Yona tzvi',
          'line2': '',
          'postalCode': '75548'
        }
      },
      {
        'externalId': '2fb76f05-3da7-4fb9-a5b5-fac21dcdcssc',
        'email': 'jnaknawf@lili.com',
        'phoneNumber': '+12125879345',
        'firstName': 'ddd',
        'lastName': 'aaa',
        'ssn': '234242342',
        'birthDate': '1994-08-07T21:00:00.000+00:00',
        'customerAddressData': {
          'city': 'Rishon Le Zion',
          'state': 'AZ',
          'line1': 'Yona tzvi',
          'line2': '',
          'postalCode': '75548'
        }
      }
    ],
    'fromRoute': '/ob/account-type',
    'isFeeABtestEnrolled': true,
    'isABtestEnrolled': true,
    'businessId': '8b5f0dc8-dc67-48c9-9e32-dff845126dbb',
    'isPersonalAndBusinessAddressSame': true
  }
}

export async function update ({method, endPoint, data = null, header, token}) {
  try {
    let res = await HTTP[method](endPoint, data, header, null, token)
    return res
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/services/entities/customerService.js